import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import LogoMark from "@/components/LogoMark";

const links = [
  { to: "/", label: "Home", testId: "nav-home-link" },
  { to: "/propaq", label: "Propaq", testId: "nav-propaq-link" },
  { to: "/catalogo", label: "Catalogo", testId: "nav-catalogo-link" },
  { to: "/risorice", label: "Risorice", testId: "nav-risorice-link" },
  { to: "/simulatore", label: "Simulatore", testId: "nav-simulatore-link" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-forest/10 bg-bone/80 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3 font-display text-xl font-extrabold tracking-tight text-forest"
        >
          <LogoMark size={36} testId="nav-logo-mark" />
          <span>
            COMM<span className="text-moss">PAQ</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.18em] transition-colors duration-300 hover:text-moss ${
                  isActive ? "text-moss" : "text-forest/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            data-testid="nav-cta-button"
            className={`rounded-full bg-moss px-6 py-2.5 text-sm uppercase tracking-[0.15em] text-bone shadow-none transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-forest hover:shadow-lg hover:shadow-moss/30 ${
              location.pathname === "/contatti" ? "bg-forest" : ""
            }`}
          >
            Contattaci
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="text-forest md:hidden"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-forest/10 bg-bone/95 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col gap-6 px-6 py-8">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-${l.testId}`}
                  onClick={() => setOpen(false)}
                  className="font-display text-3xl text-forest"
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/contatti"
                data-testid="mobile-nav-cta-button"
                onClick={() => setOpen(false)}
                className="w-fit rounded-full bg-moss px-8 py-3 text-sm uppercase tracking-[0.15em] text-bone"
              >
                Contattaci
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
